import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Modal, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";

const { TextArea } = Input;

const AddGradeModal = ({
  open,
  handleCancel,
  handleFetchData,
  prodd,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.auth);
  const { saving } = useSelector((state) => state.save);
  const [data, setData] = useState({});

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        sgId: prodd?.sgId ? prodd?.sgId : null,
        sgGradecode: formData?.sgGradecode,
        sgGradename: formData?.sgGradename,
        url: "hr/saveStaffGrade.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd ? `Edit grade ${prodd?.sgGradename}` : "Add grade details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            label="Grade Code"
            rules={[
              {
                required: true,
                message: "Enter grade Code",
              },
            ]}
          >
            <Input 
              required
              name="sgGradecode"
              onChange={onChange}
              value={formData?.sgGradecode}
              className="input"
            />
          </Form.Item>
          <Form.Item
            label="Grade Name"
            rules={[
              {
                required: true,
                message: "Enter grade name",
              },
            ]}
          >
            <Input
              required
              name="sgGradename"
              onChange={onChange}
              value={formData?.sgGradename}
              className="input"
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddGradeModal;
